export interface PaymentMethod {
  aNumber: string;
  paymentMethodID: number;
  paymentMethodNumber: string;
  description: string;
  threeDSecureCreated: string;
  isExpired: boolean;
  activationDate: Date;
  alias: string;
  cardBrand: string;
  issuerBankCode: number;
  issuerBankDescription: string;
  cardOrganization: string;
  cardType: string;
  isDefault: boolean;
  showEulaId: boolean;
  otpValidated: boolean;
  userListeningPackages: string[];
  cardId: string;
}

export interface MasterCard {
  BankIca: string;
  CardStatus: string;
  EftCode: string;
  IsMasterPassMember: string;
  LoyaltyCode: string;
  Name: string;
  ProductName: string;
  PromtCpin: string;
  UniqueId: string;
  Value1: string;
  Value2: string;
  userListeningPackages: string[];
}

export enum MasterpassOTPTypes {
  ADD_CARD = "ADD_CARD",
	RECURING_PAYMENT = "RECURING_PAYMENT",
  DERECURING_PAYMENT = "DERECURING_PAYMENT",
  LINK_CARD = "LINK_CARD"
}



// WEBPACK FOOTER //
// src/app/buy/services/payment-method.model.ts